module.exports = __webpack_public_path__ + "static/media/arrow_left.88073523.svg";